import React, { useContext } from "react"
import { OrderDetailPage as SharedOrderDetailPage } from "@stjeans/shared-frontend/orders"
import AppContext from "../../AppContext.jsx"
import api from "../../api.js"
import * as helpers from "../../helpers.js"
import LodgeOrderConfirmActionsV1 from "../components/orders/LodgeOrderConfirmActionsV1.jsx"

export default function OrderDetailPage() {
    const { app } = useContext(AppContext)

    return (
        <SharedOrderDetailPage
            app={app}
            injectBootstrap={app?.connected === false}
            api={{
                ...api,
                getManifest: async (manifestId) => {
                    const res = await api.getManifest(manifestId)
                    return res?.data ?? res
                },
            }}
            helpers={helpers}
            activeTab="order"
            showOrderNav={false}
            showWeighInNotes={false}
            showBoxUpTable={false}
            showShipmentNotes={false}
            showCreateSoButton={false}
            customerSlideoutProps={{
                enableStatus: false,
                enableCommunication: false,
                enableTypeBadges: false,
                enableLodge: false,
                ordersTableYearParam: "all",
                // @ts-ignore - lodge-only UI behavior
                disableEditCustomer: app?.connected === false,
                // @ts-ignore - lodge-only UI behavior
                editCustomerDisabledTooltip: "Cannot edit customers while offline.",
            }}
            lockEditsWhenConfirmed={true}
            editLockedToastMessage="This order is confirmed and can no longer be edited."
            // @ts-ignore - lodge-only UI behavior
            disableManifestEditWhenOffline={app?.connected === false}
            orderInformationFieldLayout={{
                left: [
                    { kind: "master", label: "Master", editable: false },
                    { kind: "manifest", label: "Manifest", linkTo: (d) => (d?.manifestId ? `/v2/manifests/${d.manifestId}` : null) },
                    { kind: "text", key: "depot", label: "Location" },
                    { kind: "pickUpAt", label: "Pick Up At" },
                    { kind: "text", key: "orderDate", label: "Order Date" },
                    { kind: "text", key: "staffInitial", label: "Initial" },
                    { kind: "text", key: "preferredContactMethod", label: "Contact Via" },
                ],
                right: [
                    { kind: "text", key: "tripCode", label: "Trip Code" },
                    { kind: "text", key: "fishTag", label: "Fish Tag" },
                    { kind: "checkbox", key: "isStaff", label: "Is Staff" },
                ],
            }}
            renderOrderStatusActions={({ Button, order, app, api, helpers, refreshOrder, onError }) => (
                <LodgeOrderConfirmActionsV1
                    Button={Button}
                    order={order}
                    app={app}
                    api={api}
                    helpers={helpers}
                    refreshOrder={refreshOrder}
                    onError={onError}
                    // @ts-ignore - lodge-only UI behavior
                    disableConfirmWhenOffline={app?.connected === false}
                />
            )}
        />
    )
}
